export async function affExternalShipmentsGetCurrentSessionUseCase(trace_id, externalShipmentRepository) {

  const result = await externalShipmentRepository.aff_get_current_session(trace_id);

  const entity = new externalShipmentRepository.aff_prepare_model(result.data);

  if (!entity.isValid()) {
    console.log(entity)
    throw new Error("External Shipments Aff get session Inválido");
  }

  return result;
}